module.exports = __webpack_public_path__ + "static/media/home-background.0d0df270.svg";